/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinancialClassSimpleViewModel } from './financialClassSimpleViewModel';
import { ARTransactionPostedProcedureViewModel } from './aRTransactionPostedProcedureViewModel';
import { CodeSimpleViewModel } from './codeSimpleViewModel';

export interface ARTransactionVisitUpdateModel {
  procedures?: Array<ARTransactionPostedProcedureViewModel> | null;
  datasetId?: string | null;
  visitId?: string | null;
  patientId?: string | null;
  insuranceId?: string | null;
  batchId?: string | null;
  visitNumber?: number;
  totalCharges?: number;
  previousPayments?: number;
  previousAdjustments?: number;
  visitBalance?: number;
  lastStatementDate?: string | null;
  arTransactionId?: string | null;
  allowedAmount?: number;
  paymentAmount?: number;
  adjustmentAmount?: number;
  adjustment2Amount?: number;
  totalAdjustment?: number;
  totalEob?: number;
  deductibleAmount?: number;
  coinsuranceAmount?: number;
  copayAmount?: number;
  icn?: string | null;
  transactionDate?: string | null;
  releaseClaim?: boolean;
  checkNumber?: string | null;
  paymentCodeId?: string | null;
  adjustmentCodeId?: string | null;
  adjustmentCode2Id?: string | null;
  paymentTypeId?: string | null;
  patientPayment?: boolean;
  paymentDate?: string | null;
  paymentCode?: CodeSimpleViewModel;
  adjustmentCode?: CodeSimpleViewModel;
  adjustmentCode2?: CodeSimpleViewModel;
  paymentType?: CodeSimpleViewModel;
  financialClass?: FinancialClassSimpleViewModel;
}
